import React from "react";
import PropTypes from 'prop-types';

class PublicLayout extends React.Component{
    render(){
        return (
        <div>
            <div className="fullPage">
                {/* <PageHeader /> */}
                {React.cloneElement(this.props.children, { } )}
                {/* <Footer /> */}
            </div>
        </div>
        );
    }
}

PublicLayout.propTypes = {
    children:PropTypes.node
};

export default PublicLayout;